import Component from '@glimmer/component'
import { isNone } from '@ember/utils'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import {
  getCellValue,
  getCellFormatConfig,
  type CustomCellSignature,
} from 'teacher-ui-client/components/stable-table/basic-table/cell'

interface ImageArgs {
  export?: string
  src?: string
  alt?: string
  width?: number
  height?: number
}

function isImageArgs(value: object): value is ImageArgs {
  return (
    (!('export' in value) || typeof value.export === 'string') &&
    (!('src' in value) || typeof value.src === 'string') &&
    (!('alt' in value) || typeof value.alt === 'string') &&
    (!('width' in value) || typeof value.width === 'number') &&
    (!('height' in value) || typeof value.height === 'number')
  )
}

export default class ImageCell extends Component<CustomCellSignature> {
  get value() {
    const value = getCellValue(this.args.tableMeta)
    return value && typeof value === 'object' && isImageArgs(value) ? value : {}
  }

  get formatEmptyConfig() {
    return getCellFormatConfig(this.args.tableMeta)
  }

  get exportValueNone() {
    return isNone(this.value.export)
  }

  get exportValuePresent() {
    return !this.exportValueNone
  }

  get imageSrcNone() {
    return isNone(this.value.src)
  }

  get imageSrcPresent() {
    return !this.imageSrcNone
  }

  get formattedExportValue() {
    return formatValue(this.value.export, this.formatEmptyConfig)
  }

  <template>
    <span data-test-basic-table-cell-image class="relative" ...attributes>
      {{#if this.imageSrcPresent}}
        <img
          data-test-image
          src={{this.value.src}}
          height={{this.value.height}}
          width={{this.value.width}}
          alt={{this.value.alt}}
          class={{if this.exportValuePresent "print:hidden"}}
        />
      {{else}}
        <span data-test-export>
          {{this.formattedExportValue}}
        </span>
      {{/if}}
      {{#if this.exportValuePresent}}
        <span data-test-export-value class="z-[-1] text-transparent print:text-black">
          {{this.formattedExportValue}}
        </span>
      {{/if}}
    </span>
  </template>
}
